export interface CountryMetadata {
  name: string;
  code: string; // ISO 3166-1 alpha-2
  dialCode: string; // International prefix
  emergencyNumbers: {
    samu: string;
    police: string;
    fire: string;
  };
}

export const COUNTRY_REGISTRY: Record<string, CountryMetadata> = {
  BJ: {
    name: 'Bénin',
    code: 'BJ',
    dialCode: '+229',
    emergencyNumbers: {
      samu: '15',
      police: '117',
      fire: '118'
    }
  },
  CM: {
    name: 'Cameroun',
    code: 'CM',
    dialCode: '+237',
    emergencyNumbers: {
      samu: '119',
      police: '117',
      fire: '118'
    }
  },
  TG: {
    name: 'Togo',
    code: 'TG',
    dialCode: '+228',
    emergencyNumbers: {
      samu: '15',
      police: '117',
      fire: '118'
    }
  },
  CI: {
    name: 'Côte d\'Ivoire',
    code: 'CI',
    dialCode: '+225',
    emergencyNumbers: {
      samu: '185',
      police: '170',
      fire: '180'
    }
  },
  SN: {
    name: 'Sénégal',
    code: 'SN',
    dialCode: '+221',
    emergencyNumbers: {
      samu: '1515',
      police: '17',
      fire: '18'
    }
  },
  GA: {
    name: 'Gabon',
    code: 'GA',
    dialCode: '+241',
    emergencyNumbers: {
      samu: '1300',
      police: '1722',
      fire: '18'
    }
  },
  FR: {
    name: 'France',
    code: 'FR',
    dialCode: '+33',
    emergencyNumbers: {
      samu: '15',
      police: '17',
      fire: '18'
    }
  }
};

export const DEFAULT_COUNTRY = COUNTRY_REGISTRY.BJ;

export const getCountryByCode = (code: string | null | undefined): CountryMetadata => {
  if (!code) return DEFAULT_COUNTRY;
  return COUNTRY_REGISTRY[code.toUpperCase()] || DEFAULT_COUNTRY;
};
